import {MaterialStorage, MaterialType} from '@domain/material-storage'
import {Material} from '@domain/materials'
import {ProductionVolume} from '@domain/shifthandover'
import {isArray} from 'lodash'

import {OTHER_MATERIAL_TYPES} from '../consts'

export const getMaterialName = (
  materials: Material[],
  productionVolume: ProductionVolume
): string => {
  const {cementType} = productionVolume

  const mappedMaterial = materials.find((material) => {
    const {pxTrendCounters} = material
    if (isArray(pxTrendCounters)) return pxTrendCounters.includes(cementType)
    return pxTrendCounters === cementType
  })

  return mappedMaterial ? mappedMaterial.name : cementType
}

export const sortMaterialStorage = (data: MaterialStorage[]): MaterialStorage[] =>
  data.toSorted((a, b) => {
    if (
      a.capacity === 0 &&
      a.currentStorageLevel.level === 0 &&
      b.capacity === 0 &&
      b.currentStorageLevel.level === 0
    ) {
      return 0
    } else if (a.capacity === 0 && a.currentStorageLevel.level === 0) {
      return 1
    } else if (b.capacity === 0 && b.currentStorageLevel.level === 0) {
      return -1
    } else if (a.currentStorageLevel.level === 0 && b.currentStorageLevel.level === 0) {
      return b.capacity - a.capacity
    } else if (a.currentStorageLevel.level === 0) {
      return 1
    } else if (b.currentStorageLevel.level === 0) {
      return -1
    } else {
      const fillLevelA = a.currentStorageLevel.level / a.capacity
      const fillLevelB = b.currentStorageLevel.level / b.capacity
      return fillLevelB - fillLevelA
    }
  })

const filterByMaterialType = (silos: MaterialStorage[], materialType: MaterialType) =>
  materialType === MaterialType.Fuels
    ? silos.filter((silo) => OTHER_MATERIAL_TYPES.includes(silo.materialType))
    : silos.filter((silo) => silo.materialType === materialType)

export const selectLatestSortedMaterialStorages =
  (materialType: MaterialType) =>
  (materialStorages: MaterialStorage[]): MaterialStorage[] =>
    sortMaterialStorage(filterByMaterialType(materialStorages, materialType))
